import copy from 'atoms/helpers/entities/copy.helper';

export default {
  copy,
};
